import React, { Component } from 'react';
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import { API } from '../../../constants';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import './slider.css';

class HomeRevelutionSlider extends Component {
  scrollDown = () => {
    var windowWidth = window.innerWidth;

    if (windowWidth < 480) {
      this.scrollTo(document.body, 220, 1250);
    } else if (windowWidth < 769) {
      this.scrollTo(document.body, 360, 1250);
    } else if (windowWidth < 990) {
      this.scrollTo(document.body, 450, 1250);
    } else {
      this.scrollTo(document.body, 500, 1250);
    }
  };

  scrollTo = (element, to, duration) => {
    var start = document.scrollingElement.scrollTop,
      change = to - start,
      currentTime = 0,
      increment = 20;

    var animateScroll = function () {
      var easeInOutQuad = function (t, b, c, d) {
        t /= d / 2;
        if (t < 1) return (c / 2) * t * t + b;
        t--;
        return (-c / 2) * (t * (t - 2) - 1) + b;
      };
      currentTime += increment;
      var val = easeInOutQuad(currentTime, start, change, duration);
      document.scrollingElement.scrollTop = val;
      if (currentTime < duration) {
        setTimeout(animateScroll, increment);
      }
    };
    animateScroll();
  };

  render() {
    const { heroSlider, history, basenameURL } = this.props;

    if (heroSlider.length === 0) return <></>;

    return (
      <section>
        <div style={{ position: 'relative' }}>
          <OwlCarousel
            className="owl-theme main-slider"
            autoplay
            loop
            items={1}
            nav={false}
            dots={false}>
            {heroSlider.map((slide) => {
              return (
                <div className="item slide-item" key={slide.id}>
                  <div
                    className="slide-image"
                    style={{
                      backgroundImage: `url(${API.BANNER_IMG_URL}/${encodeURI(
                        slide.image
                      )})`
                    }}
                    onClick={() =>
                      slide.url
                        ? slide.url.search('http') !== -1
                          ? (window.location.href = slide.url)
                          : history.push(`${basenameURL}${slide.url}`)
                        : null
                    }
                  />
                  <div className="slide-bg" />
                </div>
              );
            })}
          </OwlCarousel>
          <div className="down-slider">
            <i className="down pointer" onClick={() => this.scrollDown()}></i>
          </div>
        </div>
      </section>
    );
  }
}

const mapStateToProps = (state) => ({
  heroSlider: state.home.heroSlider,
  basenameURL: state.language.basenameURL
});

export default withRouter(connect(mapStateToProps)(HomeRevelutionSlider));
